define(["exports", "react", "react-intl-universal", "styled-components", "../../atoms"], function (_exports, _react, _reactIntlUniversal, _styledComponents, _atoms) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var ItemPreference = _styledComponents.default.div.withConfig({
    displayName: "Preferences__ItemPreference",
    componentId: "sc-1u8tdic-0"
  })(["h2{margin:0 0 16px;}p{font-size:1.4em;margin:0;}"]);

  var Preferences = function Preferences(_ref) {
    var local = _ref.local,
        travel = _ref.travel,
        change = _ref.change;
    return /*#__PURE__*/_react.default.createElement(ItemPreference, null, /*#__PURE__*/_react.default.createElement(_atoms.H2, null, _reactIntlUniversal.default.get('CURRICULUM.PREFERENCIAS.TITULO')), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: local.cidade
    }, /*#__PURE__*/_react.default.createElement(_atoms.P, null, _reactIntlUniversal.default.get('CURRICULUM.PREFERENCIAS.LOCAL'), local.cidade, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: local.raio
    }, ", ", _reactIntlUniversal.default.get('CURRICULUM.PREFERENCIAS.RAIO'), " ", local.raio, "km."))), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: travel
    }, /*#__PURE__*/_react.default.createElement(_atoms.P, null, _reactIntlUniversal.default.get('CURRICULUM.PREFERENCIAS.VIAGEM'))), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: change
    }, /*#__PURE__*/_react.default.createElement(_atoms.P, null, _reactIntlUniversal.default.get('CURRICULUM.PREFERENCIAS.MUDANCA'))));
  };

  Preferences.defaultProps = {
    local: {}
  };
  var _default = Preferences;
  _exports.default = _default;
});